import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'

import { Nullable } from 'cng-common/models/utils'
import { NotificationController } from 'core-components/library/popup'
import { createChangeRequest as createChangeRequestApi } from 'partner360/features/hpContacts/api'
import { IHpContactRequest } from 'partner360/features/hpContacts/api/types'

export const requestCreateChangeRequest = createAsyncThunk<
  Nullable<IHpContactRequest>,
  IFormJBPHPContactChangeRequest,
  { rejectValue: Error }
>('welcomeFlow/requestCreateChangeRequest', async (request, { rejectWithValue }) => {
  try {
    const result = await createChangeRequestApi({ request })
    return result
  } catch (error) {
    const message = error instanceof Error ? error.message : 'Failed to create change request'
    NotificationController.showError({ message })
    return rejectWithValue(
      error instanceof Error ? error : new Error('Failed to create change request')
    )
  }
})
